<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('setpaypwd.modifyPaymentPassword')}}</div>
        </div>
        <div class="wrap">
            <div class="title">
                <p>{{$t('setpaypwd.setNewPaymentPassword')}}</p>
            </div>
            <div class="write_box">
                <input :type="passwordInp" v-model="password" :placeholder="$t('setpaypwd.loginpassword')">
                <div class="eye_bi" @click="showPwd" :class="passwordInp=='text'?'eye':''"></div>
            </div>
            <div class="write_new_pwd">
                <div class="write_box">
                    <input :type="newpasswordInp" v-model="npassword" :placeholder="$t('setpaypwd.newpassword')" inputmode="numeric" pattern="[0-9]*" maxlength="6" autocomplete="new-password" @input="sanitizePaymentPassword('npassword')">
                    <div class="eye_bi" @click="showNewsPwd" :class="newpasswordInp=='text'?'eye':''"></div>
                </div>
                <div class="write_box">
                    <input :type="newpasswordInp" v-model="rpassword" :placeholder="$t('setpwd.confirmnewpassword')" inputmode="numeric" pattern="[0-9]*" maxlength="6" autocomplete="new-password" @input="sanitizePaymentPassword('rpassword')">
                    <div class="eye_bi" @click="showNewsPwd" :class="newpasswordInp=='text'?'eye':''"></div>
                </div>
            </div>
        </div>
        <div class="basic_btn" :class="password!=''&&rpassword!=''&&npassword!=''?'':'no_touch'" @click="revise">
            {{$t('setpwd.modify')}}
        </div>
    </div>
</template>

<script>
    import Fetch from '../../utils/fetch'

    export default {
        name: "setpwd",
        data() {
            return {
                password: '',
                rpassword: '',
                npassword: '',
                passwordInp: 'password',
                newpasswordInp: 'password',
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        methods: {
            sanitizePaymentPassword(field) {
                this[field] = this[field].replace(/\D/g, '').slice(0, 6);
            },
            showPwd() {
                this.passwordInp = this.passwordInp === 'password' ? 'text' : 'password';
            },
            showNewsPwd() {
                this.newpasswordInp = this.newpasswordInp === 'password' ? 'text' : 'password';
            },
            revise() {
                if (!this.password) {
                    this.$toast(this.$t('setpaypwd.loginpasswordcannotbeempty'));
                    return;
                }
                if (!this.npassword) {
                    this.$toast(this.$t('setpaypwd.newpasswordcannotbeempty'));
                    return;
                }
                if (!this.rpassword) {
                    this.$toast(this.$t('setpaypwd.confirmpasswordcannotbeempty'));
                    return;
                }
                if (this.npassword !== this.rpassword) {
                    this.$toast(this.$t('setpaypwd.inconsistent'));
                    return;
                }
                if (!/^\d{6}$/.test(this.npassword)) {
                    this.$toast(this.$t('setpaypwd.sixDigitNumber'));
                    return;
                }

                Fetch('/user/resetpaypwd', {
                    passwd: this.password,
                    npasswd: this.npassword,
                }).then(() => {
                    this.$toast({
                        background: '#07c160',
                        message: this.$t('setpwd.modifiedsuccessfully')
                    });
                    sessionStorage.setItem('pwd', this.npassword);

                    const redirect = this.$route.query.redirect;
                    if (redirect) {
                        const separator = redirect.indexOf('?') === -1 ? '?' : '&';
                        this.$router.replace(`${redirect}${separator}change`);
                    } else {
                        this.$router.replace('/safe');
                    }
                });
            },
        }
    };
</script>

<style lang="less" scoped>
	.back_left {
		background: url(../../views/images/item/back_b.png) no-repeat center center;
	}
	.big_tit{
		color: #000000;
	}
    .wrap {
        padding: 35px 20px 0 20px;
    }
    .no_touch{
        pointer-events: none;
    }

    .title {
        width: 100%;
        height: 25px;
        line-height: 25px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
            font-size: 18px;
            color: #000;
            font-weight: 400;
        }

    }

    .write_box {
        width: 100%;
        height: 45px;
        margin-top: 32px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        border-radius: 2px;
        background-color: #FFFFFF;

        input {
            width: 100%;
            height: 22px;
            line-height: 22px;
            font-size: 16px;
        }
    }

    .eye_bi {
        width: 21px;
        height: 25px;
        background: url(../images/user/eye2.png) no-repeat center center;
        background-size: 100% auto;

        &.eye {
            background: url(../images/user/eye1.png) no-repeat center center;
            background-size: 100% auto;
        }
    }

    .basic_btn {
        margin: 43px auto 0 auto;
    }

    .write_new_pwd {
        margin-top: 32px;

        .write_box:first-child {
            margin-bottom: 18px;
            margin-top: 0px;
        }

        .write_box:last-child {
            margin-top: 0px;
        }
    }
    
</style>
